export { T as Timer, b as blobToDataURL, c as createRandomId, g as getCookie, r as removeCookie, s as setCookie } from '../../Timer-c078a2ef.js';
import { _ as __assign } from '../../tslib.es6-896f83a9.js';
export { f as filterDistinct } from '../../filterDistinct-c0340793.js';
import 'js-cookie';

var buildSearchQuery = function (searchFields, query) {
    //do not use this //Sten
    if (query === null || query === '') {
        return [];
    }
    return [].concat.apply([], query.split(' ').map(function (x) {
        return searchFields.map(function (field) {
            var _a;
            return (_a = {},
                _a[field] = x,
                _a);
        });
    }));
};

var mapTextsToIntlFormat = function (texts) {
    return texts.reduce(function (prev, cur) {
        var _a;
        if (prev === void 0) { prev = {}; }
        return (__assign(__assign({}, prev), (_a = {}, _a[cur.node.key] = cur.node.value, _a)));
    }, {});
};

var groupBy = function (array, groupSelector) {
    var items = array.reduce(function (group, currentItem) {
        var selection = groupSelector(currentItem);
        var existingGroup = group.find(function (x) { return x.group == selection; });
        if (existingGroup == null) {
            existingGroup = { group: selection, items: [] };
            group.push(existingGroup);
        }
        existingGroup.items.push(currentItem);
        return group;
    }, []);
    return items;
};

var defaultAmountOptions = { maximumFractionDigits: 2 };
var twoFractionAmountOptions = { maximumFractionDigits: 2, minimumFractionDigits: 2 };
var defaultIntegerOptions = { maximumFractionDigits: 0 };
var formatInteger = function (value) { return formatAmount(value, defaultIntegerOptions); };
var formatAmount = function (value, options) {
    if (options === void 0) { options = defaultAmountOptions; }
    var result = Intl.NumberFormat('sv-SE', options)
        .format(value);
    return result;
};

export { buildSearchQuery, formatAmount, formatInteger, groupBy, mapTextsToIntlFormat, twoFractionAmountOptions };
//# sourceMappingURL=index.js.map
